import { Resource } from '../../common/schemas/public'
import { LogManager } from '../services/log-manager'
import { LogType } from '../../common/schemas/enums';


let jsloaderlm: LogManager = new LogManager();

function jsloaderDebugLog (txt: string | any[], logType: LogType = LogType.CXO) {
  let logArr = (typeof txt === "string")?[txt]:[...txt];
  logArr[0] = 'js-load ' + logArr[0];
  jsloaderlm.evaluateDebugLog(logArr, logType);
}

const status = {}

const root = process.env.SERVER_ROOT

// Load inserts ( web component js bundles ) onto the dom as scripts
export function loadComponents (inserts: Resource[], isEsm6: boolean, baseURL: string) {
  jsloaderDebugLog(['loading components for inserts: ', inserts])
  jsloaderDebugLog(['esm inserts?: ', isEsm6])

  const scriptName = (isEsm6) ? 'inserts.esm.js' : 'inserts.js'
  const scriptType = (isEsm6) ? 'module' : 'text/javascript'
  const scriptURL: string = '/components/inserts/dist/inserts/' + scriptName

  return load(scriptURL, scriptType, baseURL)
}

// Load an external js file dynamically
export function load (url: string, type: string, urlBase: string = ""): Promise<any> {
  url = (urlBase.length > 0)?`${urlBase}${url}`:`${root}${url}`
  if (status[url] === undefined) {
    const fileReference = document.createElement('script')
    fileReference.setAttribute('type', type)
    fileReference.setAttribute('src', url)
    document.head.appendChild(fileReference)
    add(url, fileReference)
  }
  return status[url]
}

// Add to the status queue to track loaded status
function add (url: string, fileref: HTMLScriptElement) {
  if (status[url] === undefined) {
    const promise = new Promise<void>((resolve, reject) => {
      fileref.onload = () => {
        jsloaderDebugLog('loaded component ' + url)
        resolve()
      }
      fileref.onerror = () => {
        jsloaderDebugLog(['failed to load component from ' + url, new Error('js-loader')])
        reject(new Error('failed ' + url))
      }
      fileref.onabort = () => {
        jsloaderDebugLog(['aborted ' + url, new Error('js-loader')])
        reject(new Error('aborted ' + url))
      }
    })
    status[url] = promise
  }
}
